(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshDrawer() {
    if (window.EBCartDrawerRefresh) return window.EBCartDrawerRefresh.refresh();
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function buildCard(product) {
    var variant = (product.variants && product.variants[0]) || {};
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var available = variant.available !== false;

    var media = el('a', {
      href: product.url,
      class: 'cart-upsell__media unstyled-link'
    });
    if (image) {
      media.appendChild(
        el('img', {
          class: 'cart-upsell__image',
          src: image,
          loading: 'lazy',
          alt: product.title || ''
        })
      );
    }

    var title = el('a', {
      href: product.url,
      class: 'cart-upsell__title unstyled-link',
      text: product.title
    });

    var price = el('div', {
      class: 'cart-upsell__price',
      text: formatMoney(product.price || (variant.price ? variant.price : 0))
    });

    var addBtn = el('button', {
      type: 'button',
      class: 'cart-upsell__add',
      'data-cart-upsell-add': '',
      'data-variant-id': String(variant.id || ''),
      text: available ? 'ADD TO CART' : 'SOLD OUT'
    });
    if (!available) addBtn.setAttribute('disabled', '');

    var info = el('div', { class: 'cart-upsell__info' }, [title, price, addBtn]);
    var card = el(
      'div',
      {
        class: 'cart-upsell__card',
        'data-cart-upsell-card': '',
        'data-product-id': String(product.id),
        'data-product-handle': product.handle || '',
        'data-variant-id': String(variant.id || '')
      },
      [media, info]
    );
    return card;
  }

  function CartUpsell(root) {
    this.root = root;
    this.track = root.querySelector('[data-cart-upsell-track]');
    this.viewport = root.querySelector('[data-cart-upsell-viewport]');
    this.nav = root.querySelector('[data-cart-upsell-nav]');
    this.prevBtn = root.querySelector('[data-cart-upsell-prev]');
    this.nextBtn = root.querySelector('[data-cart-upsell-next]');
    this.baseUrl = root.dataset.recommendationsUrl || '/recommendations/products.json';
    this.limit = parseInt(root.dataset.limit, 10) || 6;
    this.currentIndex = 0;

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.prev.bind(this));
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.next.bind(this));

    this.root.addEventListener('click', this.onClick.bind(this));

    this.hydrate();
  }

  CartUpsell.prototype.setLastProductId = function (id) {
    this.root.dataset.lastProductId = id ? String(id) : '';
  };

  CartUpsell.prototype.fetchRecommendations = function (productId) {
    if (!productId) return Promise.resolve([]);
    var self = this;
    function fetchWithIntent(intent) {
      var url =
        self.baseUrl +
        '?product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        self.limit +
        '&intent=' +
        intent;
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { return (data && data.products) || []; })
        .catch(function () { return []; });
    }
    return fetchWithIntent('related').then(function (products) {
      if (products.length) return products;
      return fetchWithIntent('complementary');
    });
  };

  CartUpsell.prototype.filterExisting = function (products, cartItemIds) {
    return products.filter(function (p) {
      return cartItemIds.indexOf(p.id) === -1;
    });
  };

  CartUpsell.prototype.render = function (products) {
    if (!this.track) return;
    this.track.innerHTML = '';
    if (!products.length) {
      this.root.hidden = true;
      return;
    }
    this.root.hidden = false;
    products.forEach(function (p) {
      this.track.appendChild(buildCard(p));
    }.bind(this));
    this.currentIndex = 0;
    this.updateNav();
    this.scrollToIndex(0);
  };

  CartUpsell.prototype.updateNav = function () {
    if (!this.nav) return;
    var cardCount = this.track.children.length;
    this.nav.hidden = cardCount <= 1;
  };

  CartUpsell.prototype.scrollToIndex = function (i) {
    var cards = this.track.children;
    if (!cards.length) return;
    i = Math.max(0, Math.min(i, cards.length - 1));
    this.currentIndex = i;
    var card = cards[i];
    if (card && this.viewport) {
      this.viewport.scrollTo({
        left: card.offsetLeft - this.track.offsetLeft,
        behavior: 'smooth'
      });
    }
  };

  CartUpsell.prototype.prev = function () {
    this.scrollToIndex(this.currentIndex - 1);
  };

  CartUpsell.prototype.next = function () {
    this.scrollToIndex(this.currentIndex + 1);
  };

  CartUpsell.prototype.hydrate = function () {
    var self = this;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var last = cart.items && cart.items[cart.items.length - 1];
        var lastId = last ? last.product_id : self.root.dataset.lastProductId;
        var ids = (cart.items || []).map(function (i) { return i.product_id; });
        self.setLastProductId(lastId);
        if (!lastId) {
          self.render([]);
          return;
        }
        self.fetchRecommendations(lastId).then(function (products) {
          self.render(self.filterExisting(products, ids));
        });
      })
      .catch(function () {});
  };

  CartUpsell.prototype.onClick = function (e) {
    var btn = e.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(); })
      .catch(function () {})
      .then(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  };

  function mountAll() {
    document.querySelectorAll('[data-cart-upsell]').forEach(function (root) {
      if (root.__upsell) return;
      root.__upsell = new CartUpsell(root);
    });
  }

  document.addEventListener('DOMContentLoaded', mountAll);

  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('[data-cart-upsell]').forEach(function (root) {
      if (root.__upsell) root.__upsell.hydrate();
      else mountAll();
    });
  });
})();
